import React from "react";
import { Link } from "@quintype/components";
import CardImage from "../../atoms/card-image";
import { object, number, array } from "prop-types";
import { TimeStamp } from "../../../arrow/components/Atoms/TimeStamp";
import { SectionTag } from "../../../arrow/components/Atoms/SectionTag";
import "./image-type-1.m.css";

const ImageType1 = ({ story, showSection = false, showSubHeadline = false, widths = [250, 375] }) => {
  const storyObj = story.story ? story.story : story;
  const accessType = storyObj.access;
  const imgS3keys = storyObj["hero-image-s3-key"];
  return (
    <Link href={`/${storyObj.slug}`}>
      <div styleName="wrapper" className="type-1">
        {showSection && <h2>{storyObj.sections[0].name}</h2>}
        {imgS3keys !== null && (
          <div>
            <CardImage
              story={storyObj}
              defaultWidth={259}
              aspectRatio={[16, 9]}
              imageType="image16x9"
              widths={widths}
            />
          </div>
        )}
      </div>
      <div styleName="text-container">
        <div className="headline-container" styleName="story-content">
          <div styleName="content-wrapper" className="content-wrapper">
            <h2 styleName="headline">
              <Link className="headline-link" href={`/${storyObj.slug}`}>
                {storyObj.headline}
              </Link>
            </h2>
            {showSubHeadline && (
              <h2 styleName="headline" className="subheadline">
                {" "}
                <Link className="subheadline" href={`/${storyObj.slug}`}>
                  {storyObj.subheadline}
                </Link>
              </h2>
            )}
            <div styleName="meta-info">
              <div className="section-tag">
                <SectionTag story={storyObj} />
              </div>
              <div className="time-stamp-layout1">
                <TimeStamp story={storyObj} />
              </div>
              {(accessType === "login" || accessType === "subscription") && (
                <div>
                  <i class="ri-star-fill"></i>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ImageType1;

ImageType1.propTypes = {
  story: object,
  headlineLimit: number,
  widths: array,
};
